module.exports = __webpack_public_path__ + "img/pregnant.599ae030.svg";